"use client";

import { env } from "@/lib/env";

import BackButton from "@/components/creations/back-button";
import { glassCardVariants } from "@/components/creations/glass-card";
import ProjectCard, {
  ProjectCardSkeleton,
} from "@/components/creations/projects/project-card";
import { useProjects } from "@/hooks/use-projects";
import { ThemeToggle } from "@/components/ui/theme-toggle";

export default function ProjectsPage() {
  const { projects, loading, error, refetch } = useProjects({
  username: env.NEXT_PUBLIC_GITHUB_USERNAME,
  maxProjects: 100,
});

const cleanProjects = projects?.filter(
  (project) => project.name !== "oluoko"
);
  return (
    <>
      <BackButton
        showText={false}
        className="hover:text-primary top-0 left-0 w-max p-1.5 md:p-3 flex justify-around hover:cursor-pointer hover:underline gap-2 text-xl items-center"
      />
      <div
        className={glassCardVariants({
          variant: "cardLike",
          className: "my-20 md:my-48 mx-4 md:mx-10 p-4 md:p-10",
        })}
      >
        {loading ? (
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
            {[1, 2, 3].map((i) => (
              <ProjectCardSkeleton key={i} />
            ))}
          </div>
        ) : (
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
            {cleanProjects.map((project) => (
              <ProjectCard project={project} key={project.id} />
            ))}
          </div>
        )}
      </div>
    </>
  );
}
